import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Optional, ViewChild } from '@angular/core';
import { ButtonComponent } from '@components/shared/button/button.component';
import { ButtonType } from '@models/enums/components/Button/ButtonType.enum';
import { PortalService } from '@services/portal.service';
import Splide from '@splidejs/splide';
import anime from 'animejs';

@Component({
  selector: 'app-benefits-fullscreen-carousel',
  standalone: true,
  imports: [
    ButtonComponent
  ],
  templateUrl: './benefits-fullscreen-carousel.component.html',
  styleUrl: './benefits-fullscreen-carousel.component.css'
})
export class BenefitsFullscreenCarouselComponent implements AfterViewInit{

  constructor(
    @Optional() @Inject('CarouselData') 
    public  carouselData: {index: number, images: string[],title: string, descriptions: string[]},
    private portal: PortalService,
    private cdr: ChangeDetectorRef
    
  ) {}

  // VIEW CHILD
  @ViewChild('benefitsFullscreen')
  public readonly container!: ElementRef<HTMLDivElement>;

  @ViewChild('carousel', {static: true, read: ElementRef})
  public readonly carousel!: ElementRef;

  // HOST LISTENERS
  @HostListener('window:keydown', ['$event'])
  private closeFullScreen(event: KeyboardEvent): void {
    
    if (event.key === 'Escape') {
      event.preventDefault();
      this.toggleContainer(false);
    }

  }

  // COMPONENT STATE
  public splide!: Splide;
  public readonly btnType: ButtonType = ButtonType.Pill;



  // GETTERS
  public get title(): string {
    return this.carouselData?.title || '';
  }

  public get text(): string {
    return this.carouselData?.descriptions[this.splide.index ?? 0]
  }

  public get images(): string[] {
    return this.carouselData?.images || [];
  }

  public get index(): number {
    return this.splide ? this.splide.index + 1 : 0;
  }

  public get total(): number {
    return this.images.length;
  }

  // LIFECYCLE HOOKS
  public ngAfterViewInit(): void {
    this.initComponent();
  }

  public toggleContainer(show: boolean): void {

    anime({
      targets: this.container.nativeElement,
      opacity: show ? 1 : 0,
      duration: 300,
      easing: 'easeInOutQuad',
      complete: () => { if (!show) { this.portal.resetPortal(); }} 
    })

  }


  private setCarousel(): void {
     
    this.splide = new Splide(this.carousel.nativeElement, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: '1rem',
      drag:       this.total === 1 ? false : true,
      pagination: this.total === 1 ? false : true,
      arrows:     this.total === 1 ? false : true,     
    });
   
    this.splide.mount();

    if(this.carouselData.index !== 0) this.splide.go(this.carouselData.index);
    
    this.cdr.detectChanges();

  }

  private initComponent(): void {

    this.setCarousel();
    this.toggleContainer(true);

  }

  

}
